import React from 'react';
import LocationRefStepper from 'component/page/detail/Itineraries/HopOnHopOffItinerary/LocationRefStepper/LocationRefStepper';
import { Stepper } from 'component/common/temporary-exports';
import { LocationRef } from 'gql/autogen/LocationRef';
import { Location } from 'gql/autogen/Location';
import { StepperIcon } from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryStep';

interface OwnProps {
    locationRef: LocationRef;
    locations: Location[];
}
const LocationRefContainer: React.FC<OwnProps> = (props) => {
    const { locationRef, locations } = props;
    if (!locationRef.locationRefId || locations.length === 0) {
        return null;
    }
    return (
        <Stepper.Step noBackground={true} icon={<StepperIcon id="fill.symbol.pin" size="14" />}>
            <LocationRefStepper locationRef={locationRef} locations={locations} />
        </Stepper.Step>
    );
};
LocationRefContainer.displayName = 'LocationRefContainer';

export default LocationRefContainer;
